import IService from '../IService';

/**
 * @namespace app.api.objectTracking
 */
export default IService.extend({
  /**
   * Create an object tracking job for a story's asset video.
   * `userId` is intentionally not sent - the server overrides it with the
   * authenticated user (ObjectTrackingController#createTrackingJob).
   *
   * @param storyId {String}
   * @param assetUUID {String}
   * @param payload {Object} see buildTrackingPayload
   * @return {Promise<String>} the tracking id
   */
  post(storyId, assetUUID, payload) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl(`/api/v1/objectTracking/${storyId}/${assetUUID}`),
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(payload),

        // every outcome must settle the promise - apply is blocked until it does
        error: (jqXHR) => {
          reject(this.createError(jqXHR));
        },

        dataType: 'json',
        success: (res) => {
          if (res && res.id) {
            resolve(res.id);
          } else {
            reject({ error: 'objectTracking: response has no id' });
          }
        },
      });
    });
  },

  /**
   * Read a tracking job. Used to catch up on a job that was started before the
   * page was reloaded - only `status` is of interest.
   *
   * @param id {String}
   * @return {Promise<Object>} ObjectTrackingResponseModel
   */
  get(id) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl(`/api/v1/objectTracking/${id}`),
        type: 'GET',

        error: (jqXHR) => {
          reject(this.createError(jqXHR));
        },

        dataType: 'json',
        success: (res) => {
          if (res && res.status) {
            resolve(res);
          } else {
            reject({ error: 'objectTracking: response has no status' });
          }
        },
      });
    });
  },
});
